/* ======================================================
   THE FR HOUSE — MEGA MENU (CLICK ONLY)
   Stable | No hover | No first-tap issues | Dawn safe
====================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const DESKTOP_BREAKPOINT = 990;

  // Run only on desktop
  if (window.innerWidth < DESKTOP_BREAKPOINT) return;

  const menus = document.querySelectorAll('.mega-menu');

  menus.forEach(menu => {
    const summary = menu.querySelector('summary');

    if (!summary) return;

    /* =========================
       CLICK TO TOGGLE
    ========================= */
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const isOpen = menu.hasAttribute('open');

      // Close all menus
      document.querySelectorAll('.mega-menu').forEach(m => {
        m.removeAttribute('open');
      });

      // Toggle current
      if (!isOpen) {
        menu.setAttribute('open', true);
      }
    });

  });

  /* =========================
     CLICK OUTSIDE → CLOSE
  ========================= */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.mega-menu')) {
      document.querySelectorAll('.mega-menu').forEach(m => {
        m.removeAttribute('open');
      });
    }
  });

});